export default "__VITE_PUBLIC_ASSET__c8c8ad23__"